import { gql } from '@/service/gql'
import { type SanitizedResult } from '@amzn/amp-gql'
// language=GraphQL
export const imageFieldsFrag = gql(`
    fragment imageFields on Image @_unmask {
        width
        height
        url
        imageType
        colorPalette {
            dominantColors {
                color
            }
        }
    }
`)

export type ImageFields = SanitizedResult<typeof imageFieldsFrag>
